import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { Text, Flex } from '@atlaskit/primitives/compiled';
import Heading from '@atlaskit/heading';

import { ApprovalStatusButton } from './ApprovalStatusButton.tsx';

const i18n = defineMessages({
	startApprovalTitle: {
		id: 'content-state.contentStateInfoPopup.approvalStatusButton.start-approval-title',
		defaultMessage: 'Start approval',
		description: 'The text is shown as the label on a button in the content state info popup that allows a user to initiate an approval workflow for the current page.',
	},
	startApprovalDescription: {
		id: 'content-state.contentStateInfoPopup.approvalStatusButton.start-approval-description',
		defaultMessage: 'Get feedback and move work forward',
		description: 'Description for the start approval button',
	},
});

export const StartApprovalButton = ({ onClick }: { onClick?: () => void }) => {
	const { formatMessage } = useIntl();

	return (
		<ApprovalStatusButton onClick={onClick}>
			<Flex direction="column" alignItems="start" gap="space.025">
				<Heading size="xsmall">{formatMessage(i18n.startApprovalTitle)}</Heading>
				<Text size="small" color="color.text.subtlest">
					{formatMessage(i18n.startApprovalDescription)}
				</Text>
			</Flex>
		</ApprovalStatusButton>
	);
};
